import {gql} from "@apollo/client";

export const MARKETPLACE_LISTING_FIELDS = gql`
    fragment MarketplaceListingFields on MarketplaceListingType {
        id
        title
        slug
        description
        listingType
        condition
        priceAmount
        currency
        address
        city
        state
        country
        latitude
        longitude
        placeId
        status
        promotionStatus
        promotionCampaignId
        publishedAt
        expiresAt
        category { id name slug }
        sport { id name }
        images { id image isPrimary }
        rentalTerms {
            priceAmount
            currency
            pricingPeriod
            minimumPeriod
            maximumPeriod
            depositRequired
            terms
        }
    }
`;

export const MARKETPLACE_CATEGORIES = gql`
    query MarketplaceCategories {
        marketplaceCategories { id name slug }
    }
`;

export const MARKETPLACE_LISTING = gql`
    ${MARKETPLACE_LISTING_FIELDS}
    query MarketplaceListing($id: Int!) {
        marketplaceListing(id: $id) { ...MarketplaceListingFields }
    }
`;

export const MY_MARKETPLACE_LISTINGS = gql`
    ${MARKETPLACE_LISTING_FIELDS}
    query MyMarketplaceListings($categoryId: Int, $sportId: Int, $listingType: String, $condition: String, $status: String, $city: String, $state: String, $country: String, $minPrice: Decimal, $maxPrice: Decimal, $search: String, $page: Int, $pageSize: Int) {
        marketplaceMyListings(categoryId: $categoryId, sportId: $sportId, listingType: $listingType, condition: $condition, status: $status, city: $city, state: $state, country: $country, minPrice: $minPrice, maxPrice: $maxPrice, search: $search, page: $page, pageSize: $pageSize) {
            page
            pages
            hasNext
            hasPrev
            totalCount
            statusCounts
            objects { ...MarketplaceListingFields }
        }
    }
`;

export const MARKETPLACE_LISTING_CREATION_ACCESS = gql`
    query MarketplaceListingCreationAccess($organizationId: Int) {
        marketplaceListingCreationAccess(organizationId: $organizationId) {
            canCreate
            enterpriseAccess
            availableCredits
            listingLimit
            activeListings
            remainingListings
        }
    }
`;

export const MARKETPLACE_PROMOTION_INPUTS = gql`
    query MarketplacePromotionInputs {
        sponsors(page: 1, pageSize: 100) {
            objects { id name isActive billingCurrency }
        }
        adZones { key name description }
    }
`;

export const PROMOTE_MARKETPLACE_LISTING = gql`
    mutation PromoteMarketplaceListing($listingId: Int!, $sponsorId: ID!, $zoneKeys: [String!]!, $name: String) {
        promoteMarketplaceListing(listingId: $listingId, sponsorId: $sponsorId, zoneKeys: $zoneKeys, name: $name) {
            success
            errors
            campaign { id name status }
        }
    }
`;

export const CREATE_MARKETPLACE_LISTING = gql`
    mutation CreateMarketplaceListing($input: CreateMarketplaceListingInput!, $organizationId: Int) {
        createMarketplaceListing(input: $input, organizationId: $organizationId) {
            listing { id title slug status }
        }
    }
`;

export const UPDATE_MARKETPLACE_LISTING = gql`
    mutation UpdateMarketplaceListing($id: Int!, $input: UpdateMarketplaceListingInput!) {
        updateMarketplaceListing(id: $id, input: $input) {
            listing { id title slug status }
        }
    }
`;

export const CHANGE_MARKETPLACE_LISTING_STATUS = gql`
    mutation ChangeMarketplaceListingStatus($id: Int!, $status: String!, $reason: String) {
        changeMarketplaceListingStatus(id: $id, status: $status, reason: $reason) {
            listing { id status }
        }
    }
`;

export const RENEW_MARKETPLACE_LISTING = gql`
    mutation RenewMarketplaceListing($id: Int!, $expiresAt: DateTime!) {
        renewMarketplaceListing(id: $id, expiresAt: $expiresAt) { listing { id status expiresAt } }
    }
`;

export const ADD_MARKETPLACE_LISTING_IMAGE = gql`
    mutation AddMarketplaceListingImage($listingId: Int!, $image: Upload!, $sortOrder: Int, $isPrimary: Boolean) {
        addMarketplaceListingImage(listingId: $listingId, image: $image, sortOrder: $sortOrder, isPrimary: $isPrimary) {
            image { id image isPrimary }
        }
    }
`;

export const DELETE_MARKETPLACE_LISTING_IMAGE = gql`
    mutation DeleteMarketplaceListingImage($id: Int!) {
        deleteMarketplaceListingImage(id: $id) { success }
    }
`;

export const UPSERT_MARKETPLACE_RENTAL_TERMS = gql`
    mutation UpsertMarketplaceRentalTerms($listingId: Int!, $input: MarketplaceRentalTermsInput!) {
        upsertMarketplaceRentalTerms(listingId: $listingId, input: $input) {
            rentalTerms { priceAmount currency pricingPeriod minimumPeriod maximumPeriod depositRequired terms }
        }
    }
`;
